'use strict';

/**
 * Listing of trash items
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCompositeView = require('base/Colido.CompositeView');
var TrashListItem = require('./trash-list-item');
var TrashListEmptyItem = require('./trash-list-empty');

var template = require('../../templates/partials/trash-list.hbs');

var TrashList = ColidoCompositeView.extend({
    template: template,

    tagName: 'table',

    className: 'table table-overflow table-striped table-without-margin',

    childView: TrashListItem,

    emptyView: TrashListEmptyItem,

    childViewContainer: 'tbody',

    sortDefault: 'timestamp.desc',
});

module.exports = TrashList;